/**
 * WordPress API
 */
import axios from 'axios'
import store from '@/store'

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  config.timeout = 10000
  config.baseURL = store.getters['wordpress/account/url']
  if (!config.headers) config.headers = {}
  if (!config.headers['Content-Type']) config.headers['Content-Type'] = 'application/json'
  if (config.url !== '/wp-json/jwt-auth/v1/token') config.headers['Authorization'] = store.getters['wordpress/account/authorizationHeader']
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

export default {
  /**
   * WP REST APIにアクセスするためのJWTを取得
   *
   * POST /wp-json/jwt-auth/v1/token
   */
  getToken ({username, password}) {
    return axios.post('/wp-json/jwt-auth/v1/token', {username, password})
  },

  /**
   * ユーザー一覧を取得
   *
   * GET /wp-json/wp/v2/users
   */
  getUsers () {
    return axios.get('/wp-json/wp/v2/users')
  },

  /**
   * 投稿ページ一覧の取得
   *
   * GET /wp-json/wp/v2/posts
   */
  getPosts () {
    return axios.get('/wp-json/wp/v2/posts', {
      params: {
        status: 'publish,draft,private',
        order: 'desc',
        per_page: 100
      }
    })
  },

  /**
   * 新規投稿の作成
   *
   * POST /wp-json/wp/v2/posts
   */
  createPost (data, config) {
    return axios.post('/wp-json/wp/v2/posts', data, config)
  },

  /**
   * 投稿の更新
   *
   * POST /wp-json/wp/v2/posts/{id}
   */
  updatePost (id, data) {
    return axios.post(`/wp-json/wp/v2/posts/${id}`, data)
  },

  /**
   * 投稿の削除
   *
   * DELETE /wp-json/wp/v2/posts/{id}
   */
  deletePost (id) {
    return axios.delete(`/wp-json/wp/v2/posts/${id}`, {data: {force: true}})
  },

  /**
   * 固定ページ一覧の取得
   *
   * GET /wp-json/wp/v2/pages
   */
  getPages () {
    return axios.get('/wp-json/wp/v2/pages', {
      params: {
        status: 'publish,draft,private',
        order: 'asc',
        orderby: 'menu_order',
        per_page: 100
      }
    })
  },

  /**
   * 新規固定ページの作成
   *
   * POST /wp-json/wp/v2/pages
   */
  createPage (data, config) {
    return axios.post('/wp-json/wp/v2/pages', data, config)
  },

  /**
   * 固定ページの更新
   *
   * POST /wp-json/wp/v2/pages/{id}
   */
  updatePage (id, data) {
    return axios.post(`/wp-json/wp/v2/pages/${id}`, data)
  },

  /**
   * 固定ページの削除
   *
   * DELETE /wp-json/wp/v2/pages/{id}
   */
  deletePage (id) {
    return axios.delete(`/wp-json/wp/v2/pages/${id}`, {data: {force: true}})
  },

  /**
   * メディア一覧の取得
   *
   * GET /wp-json/wp/v2/media
   */
  getMedia () {
    return axios.get('/wp-json/wp/v2/media', {
      params: {per_page: 100}
    })
  },

  /**
   * 新規メディアの作成
   *
   * POST /wp-json/wp/v2/media
   */
  createMedia (data, config) {
    return axios.post('/wp-json/wp/v2/media', data, config)
  },

  /**
   * メディアの更新
   *
   * POST /wp-json/wp/v2/media/{id}
   */
  updateMedia (id, data) {
    return axios.post(`/wp-json/wp/v2/media/${id}`, data)
  },

  /**
   * メディアの削除
   *
   * DELETE /wp-json/wp/v2/media/{id}
   */
  deleteMedia (id) {
    return axios.delete(`/wp-json/wp/v2/media/${id}`, {data: {force: true}})
  },

  /**
   * テーマ情報の取得
   *
   * GET /wp-json/evsma-press/v1/themes
   */
  getThemes () {
    return axios.get('/wp-json/evsma-press/v1/themes')
  },

  /**
   * テーマ情報の更新
   *
   * POST /wp-json/evsma-press/v1/themes
   */
  updateThemes (data) {
    return axios.post('/wp-json/evsma-press/v1/themes', data)
  },

  /**
   * 設定情報の取得
   *
   * GET /wp-json/evsma-press/v1/settings
   */
  getSettings () {
    return axios.get('/wp-json/evsma-press/v1/settings')
  },

  /**
   * 設定情報の更新
   *
   * POST /wp-json/evsma-press/v1/settings
   */
  updateSettings (data) {
    return axios.post('/wp-json/evsma-press/v1/settings', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/wordpress.js